export default "__VITE_ASSET__LsbNyvMJ__"